/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    type: PropTypes.oneOf(['facebook', 'twitter', 'instagram', 'tiktok', 'youtube', 'linkedin']),
    className: PropTypes.string,
};

const defaultProps = {
    type: 'facebook',
    className: null,
};

const Social = ({ type, className }) => (
    <svg
        className={classNames([
            {
                [className]: className !== null,
            },
        ])}
        xmlns="http://www.w3.org/2000/svg"
        width="25.9"
        height="27.54"
        viewBox="0 0 25.9 27.54"
        fill="currentColor"
    >
        {type === 'facebook' ? (
            <path d="M24.16,1.17H1.74A1.39,1.39,0,0,0,.35,2.56V25a1.39,1.39,0,0,0,1.39,1.39H13.81V16.61h-3.3v-3.8H13.8V10c0-3.25,2-5,4.88-5a24.07,24.07,0,0,1,2.93.15v3.4h-2c-1.59,0-1.89.75-1.89,1.85v2.43h3.77L21,16.6H17.73v9.76h6.43A1.38,1.38,0,0,0,25.54,25V2.56A1.38,1.38,0,0,0,24.16,1.17Z" />
        ) : null}
        {type === 'twitter' ? (
            <path d="M25.86,5.77a11.06,11.06,0,0,1-3,.83,5.28,5.28,0,0,0,2.32-2.93A10.39,10.39,0,0,1,21.78,5a5.29,5.29,0,0,0-9.15,3.62,5.41,5.41,0,0,0,.13,1.21A15,15,0,0,1,1.84,4.28a5.31,5.31,0,0,0,1.63,7.05,5.3,5.3,0,0,1-2.4-.66v.07a5.3,5.3,0,0,0,4.25,5.19A5.36,5.36,0,0,1,2.93,16a5.28,5.28,0,0,0,4.94,3.67A10.63,10.63,0,0,1,1.3,22,10.66,10.66,0,0,1,0,21.87a14.93,14.93,0,0,0,8.13,2.38A14.94,14.94,0,0,0,23.23,9.19V8.5A10.83,10.83,0,0,0,25.86,5.77Z" />
        ) : null}
        {type === 'youtube' ? (
            <path d="M25.85,18.92a3.69,3.69,0,0,1-3.69,3.68H3.73A3.68,3.68,0,0,1,.05,18.92V8.62A3.69,3.69,0,0,1,3.73,4.93H22.16a3.7,3.7,0,0,1,3.69,3.69Zm-15.57-2,7-3.61-7-3.61Z" />
        ) : null}
        {type === 'instagram' ? (
            <>
                <path d="M12.92,3.2c3.45,0,3.86,0,5.22.07a6.94,6.94,0,0,1,2.39.45A4.27,4.27,0,0,1,23,6.16a6.8,6.8,0,0,1,.44,2.4c.07,1.36.08,1.77.08,5.21s0,3.86-.08,5.22A6.7,6.7,0,0,1,23,21.38a4.28,4.28,0,0,1-2.45,2.45,6.7,6.7,0,0,1-2.39.44c-1.36.07-1.77.08-5.22.08s-3.85,0-5.21-.08a6.8,6.8,0,0,1-2.4-.44,4.29,4.29,0,0,1-2.42-2.45A7.28,7.28,0,0,1,2.45,19c-.06-1.36-.08-1.77-.08-5.21s0-3.86.08-5.22a7.17,7.17,0,0,1,.44-2.39A4.33,4.33,0,0,1,5.31,3.74a7,7,0,0,1,2.4-.45c1.36-.06,1.77-.07,5.21-.07m0-2.33C9.42.89,9,.89,7.61,1a9.36,9.36,0,0,0-3.14.6A6.54,6.54,0,0,0,.68,5.37,9.3,9.3,0,0,0,.08,8.5C0,9.88,0,10.32,0,13.82s0,3.94.08,5.31a9.38,9.38,0,0,0,.65,3.09A6.5,6.5,0,0,0,4.52,26a9.56,9.56,0,0,0,3.13.61c1.38.06,1.82.07,5.32.07s3.94,0,5.32-.07A9.56,9.56,0,0,0,21.42,26a6.54,6.54,0,0,0,3.8-3.79,9.55,9.55,0,0,0,.6-3.13c.06-1.38.08-1.82.08-5.32s0-3.94-.08-5.32a9.55,9.55,0,0,0-.6-3.13,6.59,6.59,0,0,0-3.8-3.8,9.55,9.55,0,0,0-3.13-.6C16.91.86,16.47.84,13,.84Z" />
                <path d="M12.92,7.14a6.63,6.63,0,1,0,6.63,6.63,6.63,6.63,0,0,0-6.63-6.63Zm0,10.93a4.3,4.3,0,1,1,4.3-4.3h0A4.3,4.3,0,0,1,12.92,18.07Z" />
                <circle cx="19.81" cy="6.88" r="1.55" />
            </>
        ) : null}
        {type === 'tiktok' ? (
            <path d="M25,11.32V6.64h0a5.77,5.77,0,0,1-1.38-.14h0a7.38,7.38,0,0,1-3.66-2.11l.09.06a6.18,6.18,0,0,1-1.59-3.27h0A5,5,0,0,1,18.37,0H13.6V18.31c0,3.4-3.06,5.64-5.82,4.08h0c-4.27-2.08-1.5-8.88,3-7.35V11.31h0V10.22C2.9,8.86-2.47,19.38,3.4,24.94h0c4.18,4.56,12.37,2.83,14.41-3,1-2,.42-10.45.58-12.73A11.69,11.69,0,0,0,25,11.32Z" />
        ) : null}
        {type === 'linkedin' ? (
            <path d="M23.77,1.07H2.12A1.87,1.87,0,0,0,.25,2.9V24.64a1.87,1.87,0,0,0,1.87,1.83H23.77a1.86,1.86,0,0,0,1.88-1.83V2.9A1.86,1.86,0,0,0,23.77,1.07Zm-16,21.64H4V10.59H7.78Zm.3-16A2.2,2.2,0,0,1,5.9,8.94h0A2.19,2.19,0,1,1,8.08,6.75Zm13.81,16H18.13V16.82c0-1.41,0-3.22-2-3.22s-2.26,1.54-2.26,3.12v6H10.15V10.59h3.61v1.66h.05a4,4,0,0,1,3.57-2c3.81,0,4.51,2.51,4.51,5.77Z" />
        ) : null}
    </svg>
);

Social.propTypes = propTypes;
Social.defaultProps = defaultProps;

export default Social;
